import { GlobalOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { Flex, Tag } from "antd";
export const ContactoPersonaColumn = ({ telefono, email, website }) => {
  return (
    <Flex gap={2} vertical align="start">
      {telefono && <Tag icon={<PhoneOutlined />}>{telefono}</Tag>}
      {email && <Tag icon={<MailOutlined />}>{email}</Tag>}
      {website && <Tag icon={<GlobalOutlined />}>{website}</Tag>}
    </Flex>
  );
};
